module.exports = __webpack_public_path__ + "img/italic-01.ca7b1eac.svg";